import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "planning-tutorial-msg-2-top",
  "use": "planning-tutorial-msg-2-top-usage",
  "viewBox": "0 0 68 111",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 111\" id=\"planning-tutorial-msg-2-top\"><path fill=\"#C5C5C5\" d=\"M.798 3.027.643 2.98l-.274.89-.065.043 4.91 7.037.82-.573-4.16-5.96c42.914 13.84 64.357 49.093 64.357 105.88h1c0-57.136-21.645-92.775-64.913-106.79L8.85 1.25 8.525.306.782 2.98zm.655.78.425.61a83 83 0 0 0-1.53-.483l.02-.066.58-.405.16.46.345-.118zm-.655-.78q.765.236 1.52.48l-.865.3-.326-.466-.178.127-.154-.438z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol